import * as React from "react";
const SvgFiRrPlayPause = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 21a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v16a1 1 0 0 1-1 1m-4 0a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v16a1 1 0 0 1-1 1m-13.673-.271a3.35 3.35 0 0 1-1.509-.367A3.26 3.26 0 0 1 1 17.404V6.597a3.26 3.26 0 0 1 1.817-2.958 3.3 3.3 0 0 1 3.46.285l7.368 5.402A3.29 3.29 0 0 1 14.999 12a3.28 3.28 0 0 1-1.355 2.674l-7.368 5.403a3.28 3.28 0 0 1-1.949.652M4.324 5.274q-.309 0-.603.149C3.263 5.655 3 6.083 3 6.597v10.807c0 .514.263.941.721 1.174.459.232.959.19 1.372-.112l7.369-5.404c.347-.254.538-.631.538-1.061s-.191-.807-.538-1.061L5.094 5.536a1.3 1.3 0 0 0-.77-.262"
    />
  </svg>
);
export default SvgFiRrPlayPause;
